export default {
  textColor: 'var(--text-color)',
  purple50: `var(--purple-50)`,
  cardBody: 'var(--white-card-body)',
  pageBg: 'var(--page-bg)',
  dullOrange: 'var(--dull-orange)',
  dullGreen: 'var(--dull-green)',
  dullGray: 'var(--dull-gray)',
  cascadingWhite: 'var(--cascading-white)',
  USUBENI_RED: `var(--usubeni-red)`,
  WHITE: `var(--white)`,
  MIAMI_MARMALADE: `var(--orange-50)`,
  BUOYANT: `var(--dark-grey)`,
  RANGE_LAND: `var(--range-land)`,
  BOYSENBERRY_SHADOW: `var(--purple-0)`,
  TANGERINE_HAZE: `var(--orange-60)`,
  ROCKIN_RED: `var(--red-50)`,
  FOREST_GREEN: `var(--green-50)`,
  ARANCIO: `var(--arancio)`,
  ICON: `var(--icon)`,
  darkGray: 'var(--dark-grey)',
  darkGray0: 'var(--dark-grey-0)',
  deepViolet: 'var(--deep-violet)',
  green0: 'var(--green-0)',
  green10: 'var(--green-10)',
  red0: 'var(--red-0)',
  red10: 'var(--red-10)',
};
